import useDocumentTitle from '../hooks/useDocument';
import {Link} from 'react-router-dom';
import Header from '../components/header';
import Breadcrumb from '../components/breadcrumb';
import Features from '../components/features';
import CallToAction from '../components/calltoaction';
import Footer from '../components/footer';

function WorkWithUsView() {
  useDocumentTitle('Work with us-Quality-Home-Healthcare');
  return (
    <div className="body-wrapper">
      <Header />
      <Breadcrumb image={'bg-image-26'} title={'Work with us'} />

      <div className="ltn__page-details-area ltn__service-details-area mb-105">
        <div className="container">
          <div className="mb-3 color-border"></div>
          <div className="row">
            <div className="col-lg-8">
              <h2 className="text-left compassion">
                Life at Quality Health and Homecare Services
              </h2>
              <div className="ltn__page-details-inner ltn__service-details-inner">
                <p className="values_p">
                  {' '}
                  <span className="ltn__first-letter">P</span>eople are at the
                  heart of everything we do at Quality Health and Homecare
                  Services. We always recruit people who are compassionate,
                  committed to delivering high-quality care in the home, and
                  passionate about improving the lives of others.
                </p>
                <p className="values_p3">
                  Our staff, who are a part of our team deliver specialist care
                  to our clients in their homes across Worcestershire. Some of
                  these staff are healthcare assistants, support workers,
                  registered nurses, and nursery nurses. We also have our local
                  operations and central office teams who are based in Evesham,
                  Worcestershire..
                </p>
              </div>
            </div>
            <div className="col-lg-4">
              <aside className="sidebar-area ltn__right-sidebar">
                <h2 className="text-center compassion">Also see:</h2>
                <div className="widget-2 ltn__menu-widget ltn__menu-widget-2 text-uppercase">
                  <ul>
                    <li>
                      <Link to="/recruitment-process">
                        Recruitment Process
                        <span>
                          <i className="fas fa-arrow-right"></i>
                        </span>
                      </Link>
                    </li>
                    <li className="">
                      <Link to="/reward">
                        Reward and Recognition
                        <span>
                          <i className="fas fa-arrow-right"></i>
                        </span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/training">
                        Training
                        <span>
                          <i className="fas fa-arrow-right"></i>
                        </span>
                      </Link>
                    </li>
                  </ul>
                </div>
              </aside>
            </div>
          </div>
        </div>
      </div>
      <div className="call-to-action-area call-to-action-5  bg-overlay-theme-90 pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left">
                <h2 className="white-color">A great place to work</h2>
                <p className="white-color">
                  Quality Health and Homecare Services aspires to be an amazing
                  place to work. We provide long-term work assignments for our
                  healthcare workers while allowing for flexibility. To
                  guarantee that our service offers consistent care teams to our
                  clients, we engage workers in a number of different ways.
                </p>
                <p className="white-color">
                  "All of this is accomplished by a group of individuals who
                  serve as both your coworkers and your "work family."
                </p>
                <p className="white-color">
                  Someone is always available to offer a shoulder to cry on and
                  support you when you need it.
                </p>
                <p className="white-color">
                  We also provide some of the best employee benefits in the
                  healthcare industry, as well as continual training and
                  development that will help you advance your career.
                </p>
                <p className="white-color">
                  Our services offer personal and complex care 1:1 or 2:1 in the
                  client's home while managing conditions such as cerebral
                  palsy, brain and spinal injuries, global development delay,
                  motor neuron disease, etc.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="call-to-action-area call-to-action-5 pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left">
                <h2 className="compassion">
                  We’re looking for people who share our passion
                </h2>
                <p className="">
                  We are looking for caregivers who are dedicated and
                  compassionate to join our team; people who share our
                  enthusiasm for providing superior personal and complex care
                  services;People who would practice the principles outlined in
                  our values, which serve as the basis for providing care to all
                  of our clients.
                </p>
                <p>
                  We offer a one-of-a-kind opportunity to train and develop care
                  staff from non-clinical or care home backgrounds for a more
                  complex clinical position. We offer free training in
                  tracheostomy care, ventilation management, and enteral
                  feeding, to name a few.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="call-to-action-area call-to-action-5 compassion-bg pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left">
                <h2 className="white-color">Our benefits</h2>
                <p className="white-color">
                  We are able to consistently provide high-quality care packages
                  to the community thanks to the contributions of our registered
                  nurses, care assistants, and support workers. As a result, we
                  want to make sure that when you work for Quality Health and
                  Homecare Services, you get the best benefits and ongoing
                  support available!
                </p>
                <p className="white-color">
                  Working for us implies that you will be essential to an
                  astonishing group that has a tremendous effect on the
                  existence of our clients and their families each and every
                  day.
                </p>
                <div>
                  <ul className="care_bullets">
                    <li>
                      Unique reward and recognition scheme, which includes
                      rewards at six and twelve months of service.
                    </li>
                    <li>
                      Pay rates starting at a minimum of £10 per hour, paid
                      weekly.
                    </li>
                    <li>
                      Uplifts for nights, weekends and bank holiday shifts.
                    </li>
                    <li>Holiday pay in addition to your hourly rate.</li>
                    <li>Confirmed, regular rotas.</li>
                    <li>On-going training and development.</li>
                    <li>
                      Flexibility of work around your availability and required
                      hours.
                    </li>
                    <li>
                      Incentives for recommending a friend to work with us.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Features
        icon1="fas fa-chevron-right"
        icon2="fas fa-volume-up"
        text1=" Combining skills, expertise and knowledge to offer quality
                  care."
        text2="Read what our clients have to say about us.
        "
        link1="/team"
        link2="/testimonials"
        btn1="Meet our team"
        btn2="Read our testimonials"
      />
      <CallToAction />
      <Footer />
    </div>
  );
}

export default WorkWithUsView;
